// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Analysis_wrapper__1Z0Bw"};